import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { OrgChartNode } from "components/organisms/OrgTree";

import {
  addNode,
  addEmployees,
  deleteDeptManager,
  deleteDept,
  addDeptManager,
  updateNode,
} from "./utils";

export interface OrgChartReducerState {
  orgChart: OrgChartNode[];
  nodeSelected?: OrgChartNode;
}

const initialState: OrgChartReducerState = {
  orgChart: [],
  nodeSelected: undefined,
};

export const orgChartSlice = createSlice({
  name: "OrgChart",
  initialState,
  reducers: {
    setOrgChart: (state, action) => {
      state.orgChart = action.payload;
    },
    setNodeSelected: (state, action) => {
      state.nodeSelected = action.payload;
    },
    addNode: (
      state,
      action: PayloadAction<{ parentId: number; node: OrgChartNode }>
    ) => {
      state.orgChart = addNode(
        state.orgChart,
        action.payload.parentId,
        action.payload.node
      );
    },
    updateNode: (state, action: PayloadAction<{ node: OrgChartNode }>) => {
      state.orgChart = updateNode(state.orgChart, action.payload.node);
    },
    addEmployees: (
      state,
      action: PayloadAction<{
        parentId: number;
        employees: OrgChartNode["employees"];
      }>
    ) => {
      state.orgChart = addEmployees(
        state.orgChart,
        action.payload.parentId,
        action.payload.employees
      );
    },
    addDeptManager: (
      state,
      action: PayloadAction<{
        parentId: number;
        deptManagers: OrgChartNode["deptManagers"];
      }>
    ) => {
      state.orgChart = addDeptManager(
        state.orgChart,
        action.payload.parentId,
        action.payload.deptManagers
      );
    },
    deleteDeptManager: (
      state,
      action: PayloadAction<{ nodeId: number; managerId: number; role: string }>
    ) => {
      state.orgChart = deleteDeptManager(
        state.orgChart,
        action.payload.nodeId,
        action.payload.managerId,
        action.payload.role
      );
    },
    deleteDept: (state, action: PayloadAction<{ nodeId: number }>) => {
      state.orgChart = deleteDept(state.orgChart, action.payload.nodeId);
    },

    reset: () => initialState,
  },
});
